import { FeatureFlag } from 'constants-flags';

import useFlag from './useFlag';

export function useReservableHeadcountCapacityEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.SquadTechnicalSolutionsReservableHeadcountCapacity,
    false
  );

  return Boolean(isEnabled);
}
